import React from "react";
import { Leaf } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const plans = [{
  name: "Magic Trial",
  description: "Perfect for curious minds starting their very first Spanish quest.",
  price: "$0",
  period: "trial",
  isPopular: false,
  features: ["1x Live 25-min trial lesson", "Meet a friendly native teacher", "Playful intro to Spanish", "Interactive digital games", "Parent progress report"]
}, {
  name: "The Explorer",
  description: "Our most loved path for consistent, joyful learning every week.",
  price: "$145",
  period: "month",
  isPopular: true,
  features: ["4x Live 1-on-1 sessions", "Personalized learning path", "Fun homework activities", "Priority class scheduling", "Direct teacher messaging", "Certificate of Achievement"]
}, {
  name: "Language Hero",
  description: "For dedicated families ready to master Spanish through deep immersion.",
  price: "$395",
  period: "term",
  isPopular: false,
  features: ["12x Live 1-on-1 sessions", "Cultural immersion workshops", "Sibling discount included", "Full access to game library", "Premium physical workbooks"]
}];
export default function MembershipPaths() {
  return <section data-section-id="82676" id="adventure-pricing" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-secondary/20 via-background to-background pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-serif text-4xl md:text-6xl font-bold mb-6 text-foreground tracking-tight">
            Choose Your Adventure
          </h2>
          <p className="text-xl font-sans text-muted-foreground leading-relaxed">
            Join LinguaKids on an unforgettable journey. Select the learning path that best aligns with your child's curiosity and confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          {plans.map((plan, i) => <Card key={plan.name} data-index={i} className={`relative h-full flex flex-col border-2 transition-all duration-300 rounded-[2.5rem] ${plan.isPopular ? "border-primary shadow-2xl shadow-primary/20 lg:scale-105 z-10 bg-card" : "border-secondary/30 bg-card/60 hover:bg-card hover:shadow-xl"}`}>
              {plan.isPopular && <Badge variant="default" className="absolute -top-4 left-1/2 -translate-x-1/2 px-6 py-2 text-sm uppercase tracking-widest font-bold shadow-lg rounded-full bg-primary text-primary-foreground border-none">
                  Most Popular
                </Badge>}

              <CardHeader className="text-center pb-4 pt-10">
                <CardTitle className="text-3xl font-serif tracking-normal text-foreground">
                  {plan.name}
                </CardTitle>
                <CardDescription className="mt-2 h-12 font-sans text-base">
                  {plan.description}
                </CardDescription>
              </CardHeader>

              <CardContent className="flex-grow flex flex-col px-8">
                <div className="text-center mb-8 py-6 border-y border-secondary/10">
                  <span className="font-serif text-6xl font-bold text-primary">
                    {plan.price}
                  </span>
                  {plan.period && <span className="text-muted-foreground font-sans text-lg ml-1">
                      /{plan.period}
                    </span>}
                </div>

                <ul className="flex flex-col gap-4 flex-grow mb-8">
                  {plan.features.map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3 text-foreground/80 font-sans">
                      <Leaf className="size-5 text-secondary shrink-0 mt-0.5 opacity-100" />
                      <span className="leading-tight font-medium">{feature}</span>
                    </li>)}
                </ul>
              </CardContent>

              <CardFooter className="px-8 pb-10 pt-0">
                <Button asChild size="lg" variant={plan.isPopular ? "default" : "outline"} className={`w-full text-lg h-14 rounded-full font-bold transition-transform hover:scale-105 active:scale-95 ${plan.isPopular ? "bg-primary text-primary-foreground shadow-xl shadow-primary/30" : "border-secondary text-secondary hover:bg-secondary/10"}`}>
                  <Link to="/OurClassesPage">Select Path</Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}